module.exports = __webpack_public_path__ + "static/media/kgp-slide-1.f61ddd2d.jpg";